import { InitializeState, initialState } from './initialize.state';
import { createReducer, on } from '@ngrx/store';
import { environmentLoadedFailure, environmentLoadedSuccess } from '../environment/environment.actions';

import { ApiRequestType } from 'src/app/shared/enums/api.enums';
import { apiResponse } from '../api/api.actions';
import { isApi } from '../api/api.utilities';

const reducer = createReducer(
	initialState,
	on(apiResponse, (state, action): InitializeState => {
		const { isOk } = action;
		let newState;

		if (isApi(action, ApiRequestType.GET_APPLICATION_CONFIG)) {
			newState = { ...state, applicationConfigLoaded: true };
		} else if (isApi(action, ApiRequestType.GET_MERCHANT_DETAILS)) {
			newState = { ...state, merchantLoaded: isOk };
		} else if (isApi(action, ApiRequestType.GET_APPLICATION_LOCALE)) {
			newState = { ...state, defaultLocalesLoaded: true, defaultGlobalLocalesLoaded: true };
		}

		if (newState) {
			newState.initialized = isInitialized(newState);
			return newState;
		}

		return state;
	}),
	on(environmentLoadedSuccess, (state) => ({ ...state, environmentLoaded: true })),
	on(environmentLoadedFailure, (state) => ({ ...state, environmentLoaded: false }))
);

export function initializeReducer(action, state): InitializeState {
	return reducer(action, state);
}

/**
 * Checks the state to see if everything is finished initializing.
 * @param state The initialized state
 * @returns If we're initialied or not.
 */
export function isInitialized(state: InitializeState): boolean {
	return state.applicationConfigLoaded && state.merchantLoaded && state.environmentLoaded;
}
